import {
    useState,
} from 'react'

import AccordionItem, {
    AccordionItemType,
} from './ReorderableAccordionItem'

type ReorderableAccordionListProps = {
    items: AccordionItemType[],
    initialHeightVh: number,
}

export default function ReorderableAccordionList({
    items: initialItems,
    initialHeightVh,
}: Readonly<ReorderableAccordionListProps>) {
    const [
        items,
        setItems,
    ] = useState(initialItems)

    const moveItem = (index: number, direction: 'up' | 'down') => {
        const newIndex = direction === 'up' ? index - 1 : index + 1

        if (newIndex < 0 || newIndex >= items.length) return

        const newItems = [...items];

        [
            newItems[index],
            newItems[newIndex],
        ] = [
            newItems[newIndex],
            newItems[index],
        ]
        setItems(newItems)
    }

    return (
        <>
            {items.map((item, index) => {
                return (
                    <AccordionItem
                        key={item.key}
                        item={item}
                        index={index}
                        first={index === 0}
                        last={index === items.length - 1}
                        moveItem={moveItem}
                        initialHeightVh={initialHeightVh}
                    />
                )
            })}
        </>
    )
}
